/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Co2minsetpoint2Inputs */



/**
* | output |
* | --- |
* | "Minimum CO2 setpoint" |
*
* @param {Ahu_History_Key_Co2minsetpoint2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_co2minsetpoint2 = /** @type {((inputs?: Ahu_History_Key_Co2minsetpoint2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Co2minsetpoint2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Minimum CO2 setpoint")
	return /** @type {LocalizedString} */ ("Consigne minimum de CO2")
});
export { ahu_history_key_co2minsetpoint2 as "ahu_history_key_co2MinSetpoint" }